/* eslint-disable import/no-anonymous-default-export */
export default [
    {
        id: "prod_SBQi3FFyipjB3t",
        name: "(Copy) RwG Book Online",
        active: true,
        metadata: {},
        description:
            "Add a BOOK ONLINE button to your Google profile, and let users share their contact information, plus a description of their issue with a preferred service time.  Send that information to your field service management platform, or email. Businesses have seen a 50% increase in conversions when enabling self-service booking requests through their Google Business Profile. *XAPP AI is an approved Google partner authorized to manage 'Reserve with Google' (RWG) for businesses.  ",
        default_price: "price_1RH3qcJTsiGpbm2OILAGh6gS",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfUlZFTnhNR25tc2FNUVRYaVNwaVhqRE9400EsEbQFR0",
        ],
        priceInCents: 1995,
        price: "$19.95 / month",
    },
    {
        id: "prod_S5qiybsJZ2Mt6D",
        // name: "RwG Book Online",
        name: "Book Online",
        active: true,
        metadata: {},
        description:
            "Add a BOOK ONLINE button to your Google profile, and let users share their contact information, plus a description of their issue with a preferred service time.  Send that information to your field service management platform, or email. Businesses have seen a 50% increase in conversions when enabling self-service booking requests through their Google Business Profile. *XAPP AI is an approved Google partner authorized to manage 'Reserve with Google' (RWG) for businesses.  ",
        default_price: "price_1RBf1LJTsiGpbm2OdWXciXVm",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfUlZFTnhNR25tc2FNUVRYaVNwaVhqRE9400EsEbQFR0",
        ],
        priceInCents: 1995,
        price: "$19.95 / month",
    },
    {
        id: "prod_QjZlYgutfcGFGN",
        name: "XAPP AI Custom OC Studio",
        active: true,
        metadata: {},
        description: "OC Studio Custom",
        default_price: "price_1Ps6btJTsiGpbm2OOb64SjXN",
        images: [],
        priceInCents: 200000,
        price: "$2000 / month",
    },
    {
        id: "prod_QhLSfUmtdtuBIT",
        name: "XAPP AI Scheduler",
        active: true,
        metadata: {
            integrations: "true",
            "live-chat": "true",
        },
        description: null,
        default_price: "price_1PpwlgJTsiGpbm2OxZr0s5xY",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfM2xTWTlIMFE2YjNndGgzbHNPRnZUSVNy00Zsd77e5S",
        ],
        priceInCents: 34999,
        price: "$349.99 / month",
    },
    {
        id: "prod_QWS83N4REsR3LV",
        name: "XAPP AI Leads+",
        active: true,
        metadata: {
            integrations: "true",
            "live-chat": "true",
        },
        description: "Engage your website visitors to convert more leads sent to your preferred backend for followup.",
        default_price: "price_1PfPE5JTsiGpbm2O578Yz8hu",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfT0JYNlZyeHdWZjduWUZ5Vm1jWmxoS3RE00Esod3KYG",
        ],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_QWRVWvZtQH6dBI",
        name: "XAPP AI Leads",
        active: true,
        metadata: {
            chat: "true",
            "live-chat": "false",
            "reserve-with-google": "true",
        },
        description: "For Small Businesses looking to grow their digital footprint.  ",
        default_price: "price_1PfOc4JTsiGpbm2OXkRbljRq",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfWnI5dzJEMlNhTGVjWThpdWRqMWhyaWlO00oNeA3b12",
        ],
        priceInCents: 4999,
        price: "$49.99 / month",
    },
    {
        id: "prod_Q0vddoQSpGVIt7",
        name: "XAPP AI Max for Jobber",
        active: true,
        metadata: {
            chat: "true",
            form: "true",
            gbm: "true",
            "live-chat": "true",
            partner: "jobber",
            search: "true",
        },
        description: "XAPP AI Assistant + XAPP AI Scheduler for Jobber",
        default_price: "price_1PAtmZJTsiGpbm2OsKEK3ghS",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfZ1JVcm5tU2Q5WGl0bnRvb1VzT1VReVlx00OUmhnUas",
        ],
        priceInCents: 29750,
        price: "$297.5 / month",
    },
    {
        id: "prod_Q0vcEqeAgJPf1P",
        name: "XAPP AI Complete for Jobber",
        active: true,
        metadata: {
            chat: "true",
            form: "false",
            gbm: "true",
            "live-chat": "true",
            partner: "jobber",
            search: "true",
        },
        description: "XAPP AI's Full Suite of AI Powered Assistant Offerings for Jobber",
        default_price: "price_1PAtlOJTsiGpbm2OoDecT8Au",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfNEg4TFRNbUtLUHBmb0FTN2FzNG5PeWxs00GBhEw3ru",
        ],
        priceInCents: 12749,
        price: "$127.49 / month",
    },
    {
        id: "prod_Q0vaeHeo79OAMF",
        name: "XAPP AI Scheduler for Jobber",
        active: true,
        metadata: {
            chat: "true",
            form: "true",
            "live-chat": "true",
            partner: "jobber",
        },
        description: "AI Powered Scheduler to increase self-service booking events with Jobber Integration",
        default_price: "price_1PAtjgJTsiGpbm2OHFt1EEsd",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfeXZOZHozaWxDV1BtV3ViSjd6ODJYSzhn00LzHGlfLy",
        ],
        priceInCents: 25499,
        price: "$254.99 / month",
    },
    {
        id: "prod_Pz5ozkG9sQs5cE",
        name: "XAPP AI Starter",
        active: true,
        metadata: {},
        description: "Entry Level AI solution to help you agents deflect calls",
        default_price: "price_1P97d5JTsiGpbm2OCmgT4Vs7",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfWGs5MVhYMVgzMHRYcVVMOWNUNzNwTlda0022lYSofU",
        ],
        priceInCents: 0,
        price: "$ / month",
    },
    {
        id: "prod_Pz5mftE4HuDL9w",
        name: "XAPP AI Complete",
        active: true,
        metadata: {
            chat: "true",
            gbm: "true",
            "live-chat": "true",
            search: "true",
        },
        description: "XAPP AI's Full Suite of AI Powered Assistant Offerings",
        default_price: "price_1P97acJTsiGpbm2OR0Y7jthS",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfQmsxU1I4eHlHREJZSzNmUUVwbmQ0eVN1000N1gh0e1",
        ],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_Pz5ILeuI4etQgt",
        name: "XAPP AI Max",
        active: true,
        metadata: {
            chat: "true",
            form: "true",
            gbm: "true",
            "live-chat": "true",
            search: "true",
        },
        description: "XAPP AI Assistant + XAPP AI Scheduler",
        default_price: "price_1P977qJTsiGpbm2O9FeYjV39",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfaEUxMElYVmgyaXd1VGowcU9OZGZDSWZV00uBEoSqQz",
        ],
        priceInCents: 34999,
        price: "$349.99 / month",
    },
    {
        id: "prod_PyhhowcAKFU6hU",
        name: "XAPP AI Scheduler",
        active: true,
        metadata: {
            chat: "true",
            form: "true",
            legacy: "false",
            "live-chat": "true",
        },
        description: "AI Powered Scheduler to increase self-service booking events",
        default_price: "price_1P8kHfJTsiGpbm2OGHHhKQFz",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfWGQzS1g5bXdsb21XcXE1WjdQVzdJWlFX00zawNCQ9h",
        ],
        priceInCents: 29999,
        price: "$299.99 / month",
    },
    {
        id: "prod_POZTzT6ODXkvpR",
        name: "XAPP AI Max for Surefire Local",
        active: true,
        metadata: {
            SKU: "SFL Max",
            partner: "sfl",
        },
        description: "XAPP Chat and Intelligent Search and GBM for Surefire Local",
        default_price: "price_1OZmL1JTsiGpbm2OxOV6cqgp",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfYUlMS2VHMHZRaVRtM2hEeE93ZUd6UHY000mWdfClwu",
        ],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_POTEY2KVOVkAVP",
        name: "XAPP AI Complete for Surefire Local",
        active: true,
        metadata: {
            SKU: "SFL Complete",
            partner: "sfl",
        },
        description: "XAPP Chat and Intelligent Search for Surefire Local",
        default_price: "price_1OZgHsJTsiGpbm2OuCeyQkso",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfRXNYcThyTUZPVUVIbkUwQU1ZN2tmWjE200HfzML65V",
        ],
        priceInCents: 12499,
        price: "$124.99 / month",
    },
    {
        id: "prod_POSa3djoK3AHnW",
        name: "XAPP AI Leads for Surefire Local",
        active: true,
        metadata: {
            SKU: "SFL Leads",
            partner: "sfl",
        },
        description: "XAPP Chat for Surefire Local",
        default_price: "price_1OZffBJTsiGpbm2OCshCQW3z",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfNzRLdjdnUFdjVUoxazJSZzJmWlJLZWpQ00l27rIo3a",
        ],
        priceInCents: 9999,
        price: "$99.99 / month",
    },
    {
        id: "prod_OioLLzR42jsj4X",
        name: "Jobber Starter",
        active: true,
        metadata: {
            SKU: "JOB START",
            partner: "jobber",
        },
        description: "Free web chat for deflection only",
        default_price: "price_1NvMjFJTsiGpbm2O69Cs84FJ",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfQXpEYWI3QU1aWFZOVFg1MzBONlVNMUJS00d3UgfQli",
        ],
        priceInCents: 0,
        price: "$ / month",
    },
    {
        id: "prod_OYOxZy5zeau3qS",
        name: "Leads+",
        active: true,
        metadata: {
            chat: "true",
            gbm: "true",
            legacy: "true",
            "live-chat": "true",
            search: "true",
            sku: "X Max",
        },
        description: "AI Powered Chat, Intelligent Search, GBM - Legacy",
        default_price: "price_1NlI9VJTsiGpbm2O6NNHu5eR",
        images: [],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_OTWFLK7Zg3YOW5",
        name: "Jobber Max (L)",
        active: true,
        metadata: {
            chat: "true",
            gbm: "true",
            legacy: "true",
            "live-chat": "true",
            partner: "jobber",
            search: "true",
            sku: "JOB MAX",
        },
        description: "AI Powered Chat, Intelligent Search, GBM, and Jobber Integration",
        default_price: "price_1NgZD1JTsiGpbm2O6wXR8llB",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfdmJob3hFQ2JBSHpvREFNWmVaMTBUTWhv0089C6vpSt",
        ],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_OTWELanEF9Frvb",
        name: "Jobber Complete (L)",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            legacy: "true",
            "live-chat": "true",
            partner: "jobber",
            search: "true",
            sku: "JOB COMPLETE",
        },
        description: "AI Powered Chat , Intelligent Search and Jobber Integration",
        default_price: "price_1NgZBuJTsiGpbm2OosG9iLwU",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfVTFISzdZR3RZbjhjWjE2WlZCaW5lcFlI00qmd3zByW",
        ],
        priceInCents: 12499,
        price: "$124.99 / month",
    },
    {
        id: "prod_OTWBkJ5zC7gwPE",
        name: "Jobber Leads",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            "live-chat": "true",
            partner: "jobber",
            search: "false",
            sku: "JOB LEADS",
        },
        description: "AI Powered Chat and Jobber Integration",
        default_price: "price_1NgZ8vJTsiGpbm2Oq1g3aazi",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfTW9sdms4YkxYWkZHVHZNcmpEUHBRWFNW0093Cxfm3s",
        ],
        priceInCents: 9999,
        price: "$99.99 / month",
    },
    {
        id: "prod_OTVhAvqgcNT8kl",
        name: "XAPP AI Complete (L)",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            legacy: "true",
            "live-chat": "true",
            search: "true",
            sku: "X ESS",
        },
        description: "AI Powered Chat and Intelligent Search - Legacy",
        default_price: "price_1NgYg6JTsiGpbm2OuU0XyE6u",
        images: [],
        priceInCents: 12499,
        price: "$124.99 / month",
    },
    {
        id: "prod_OTVaCIwOCO7KrD",
        name: "XAPP AI Leads",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            "live-chat": "true",
            search: "false",
            sku: "X LEAD",
        },
        description: "AI Powered Chat with Lead Capture & Live Agent Take-Over",
        default_price: "price_1NgYZCJTsiGpbm2ONsULUb6h",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfM0FYbUlBVjN6NTJvTzJHcUxqNzZFdGtz00aSkwEmtI",
        ],
        priceInCents: 9999,
        price: "$99.99 / month",
    },
    {
        id: "prod_OHSayEKfN87zZ8",
        name: "LACRM Max Plan",
        active: true,
        metadata: {
            chat: "true",
            gbm: "true",
            "live-chat": "true",
            partner: "lacrm",
            search: "true",
            sku: "LACRM MAX",
        },
        description:
            "AI powered chat, intelligent search, and GBM solutions integrated with the LACRM platform.  Includes enhanced reporting",
        default_price: "price_1NUtfkJTsiGpbm2OcMAVxVB0",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfT2FTaExZcUtwNlFNaUsya2JVMFYxaWc30020o8OlMY",
        ],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
    {
        id: "prod_OHSXTXKLOTo3FO",
        name: "LACRM Complete Plan",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            partner: "lacrm",
            search: "true",
            sku: "LACRM ESS",
        },
        description:
            "AI powered chat and intelligent search solutions integrated with LACRM platform.  Includes enhanced reporting ",
        default_price: "price_1NUtcVJTsiGpbm2OG3KaA1Ca",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfYmJMSEVPbDZkbE1EM3hLclR1NnA3b1pl00tPh2Do03",
        ],
        priceInCents: 9999,
        price: "$99.99 / month",
    },
    {
        id: "prod_OHSVoiwdfyntlj",
        name: "LACRM Leads Plan",
        active: true,
        metadata: {
            chat: "true",
            gbm: "false",
            partner: "lacrm",
            search: "false",
            sku: "LACRM START",
        },
        description: "Intelligent chat solution integrated with LACRM platform",
        default_price: "price_1OuHGSJTsiGpbm2O1HI5G13D",
        images: [
            "https://files.stripe.com/links/MDB8YWNjdF8xTk5IdnhKVHNpR3BibTJPfGZsX2xpdmVfNkZZOFBJMkxDTGd6RHNWZ0FRWWxXaGFF002cTiUuzo",
        ],
        priceInCents: 6999,
        price: "$69.99 / month",
    },
    {
        id: "prod_OA2AUH1GkVSh7r",
        name: "ServiceTitan Integration - HS",
        active: true,
        metadata: {},
        description: "ServiceTitan Integration",
        default_price: "price_1NNi67JTsiGpbm2OT82sK6YS",
        images: [],
        priceInCents: 1000,
        price: "$10 / month",
    },
    {
        id: "prod_OA29T2WJBN83yd",
        name: "Additional GBM - HS",
        active: true,
        metadata: {},
        description: "GBM as an add on channel for home services",
        default_price: "price_1NNi5KJTsiGpbm2OrKWixGBo",
        images: [],
        priceInCents: 2500,
        price: "$25 / month",
    },
    {
        id: "prod_OA27nOGdsIeyBZ",
        name: "Additional  Search - HS",
        active: true,
        metadata: {},
        description: "Site search as an add on channel for home services",
        default_price: "price_1NNi3aJTsiGpbm2OZSpVw6Kt",
        images: [],
        priceInCents: 2500,
        price: "$25 / month",
    },
    {
        id: "prod_OA262xa8x9IZyK",
        name: "AI Powered Chat - HS",
        active: true,
        metadata: {},
        description: "AI powered web chat for home services",
        default_price: "price_1NNi27JTsiGpbm2OE6J22mlm",
        images: [],
        priceInCents: 14999,
        price: "$149.99 / month",
    },
];
